import React from 'react';

export default function PerfectFitProductSkeleton() {
  return (
    <div className="group/card-product relative text-gray-950 w-1/3">
      <div className="relative mb-4">
        <div className="absolute top-0 left-0 w-full p-3 lg:p-6 flex justify-between gap-2">
          <div className="transition relative flex items-center justify-center ms-auto w-7.5 h-7.5 bg-gray-300 rounded-sm z-10" />
        </div>
        <div className="w-full h-full object-cover aspect-4/5 rounded-lg bg-gray-200" />
        <span className="absolute bottom-3 lg:bottom-6 right-3 lg:right-6 opacity-0 group-hover/card-product:opacity-100 rounded-sm w-0 group-hover/card-product:w-11 lg:group-hover/card-product:w-14 h-0 group-hover/card-product:h-11 lg:group-hover/card-product:h-13.5 bg-pink-400 text-white flex justify-center items-center transition-all" />
      </div>
      <div className="lg:px-1">
        <h3 className="text-gray-400 mb-0 lg:text-2xl xl:max-w-[63%]">
          <span className="block bg-gray-200 h-4 w-2/3 rounded" />
        </h3>
        <div className="whitespace-nowrap">
          <div className="flex gap-2">
            <div className="bg-gray-200 h-4 w-1/4 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}
